<!-- <nb-chat
  title="Chat with {{ thread?.name }}"
  #chat
  [nbSpinner]="fetching"
  nbSpinnerStatus="primary"
  scrollBottom="true"
> -->
<!-- [type]="msg.files.length > 0 ? 'file' : 'text'"
msg.reply -->
  <!-- <nb-chat-message
    *ngFor="let msg of messages; let i = index; trackBy: trackById"
    [message]="msg.message"
    [sender]="msg.reply ? 'You' : thread?.name"
    [date]="parseISODate(msg.dateTime)"
    [reply]="i % 2 === 0"
    [files]="msg.files"
    [ngClass]="{ unseen: !msg.seen, fileInfo: msg.isFileInfo }"
    [type]="msg.files.length > 0 ? 'file' : 'text'"
    dateFormat="MMM dd, HH:mm aa"
  >
  </nb-chat-message>

</nb-chat>
<div class="send-message-container d-flex justify-content-center align-items-center">
  <nb-chat-form (send)="sendMessage($event)" class="flex-grow-1" [dropFiles]="true" *ngIf="showInput"></nb-chat-form> -->
  <!--  audio recorder nbButton
  (click)="onRecord()"-->
  <!-- <app-audio-recorder class="mr-1" *ngIf="showAudio" (onRecordingStart)="showInput = false" (onRecordingSend)="onRecordingSend($event)" (onRecordingCancel)="showInput=true"></app-audio-recorder>
</div> -->
<nb-card class="d-flex flex-column h-100">
  <nb-card-header class="chat-header" style=" padding-right: 45px !important;
  padding-top: 20px !important;">
    Chat with {{ thread?.name }}
  </nb-card-header>
  <nb-card-body #chatBody class="flex-grow-1 messages" [nbSpinner]="fetching"
  nbSpinnerStatus="primary" scrollBottom="true">
    <app-message *ngFor="let msg of messages; let i = index; trackBy: trackById"
    [senderName]="msg.reply ? 'You' : thread?.name"
    [message]="msg"
      ></app-message>
  </nb-card-body>
  <nb-card-footer class="chat-footer p-0 d-flex justify-content-center align-items-center" [class.mb-40]="isKeyboardOpen | async">
      <nb-chat-form id="nb-chat-form" (send)="sendMessage($event)" class="flex-grow-1" [dropFiles]="true" [hidden]="!showInput"></nb-chat-form>
      <button nbButton [hidden]="!(showInput && showAudio)" status="primary" class="rounded-circle mr-1" (click)="fileInput.click()">
        <nb-icon icon="file-add-outline"></nb-icon>
      </button>
      <app-audio-recorder class="mr-3" *ngIf="showAudio" (onRecordingStart)="startRecording()" (onRecordingCancel)="stopRecording()" (onRecordingSend)="onRecordingSend($event)"></app-audio-recorder>
  </nb-card-footer>
</nb-card>
<input #fileInput multiple type="file" class="d-none" (change)="sendMessage(fileInput)"/>
